<template lang="pug">
	
	.flag
		.flag-wrapper(style="background-image: url(assets/images/joey-flag-small.png)")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../utils/scroller.js'
	import Ticker from '../utils/ticker.js'
	import Section from '../abstracts/section'
	
  @Component({
		name: 'Flag',
		components: {  },
		props: ["x","y"]
	})

	class Flag extends Vue {

		mounted () {
			this.init()
		}

		init () {

			this.gap = 40
			this.steps = 11
			this.random = Math.random() * 11

			this._dom()
			this.setPosition()
		}

		_dom () {
			this.$flag = this.$el.querySelector('.flag-wrapper')
		}

		setPosition () {
			this.$el.style.left = this.x * window.innerWidth / 1440 + "px"
			this.$el.style.top = this.y * window.innerHeight / 900 + "px"
		}

		update (pos) {
			const to = Math.floor((pos*0.05 + this.random)%this.steps)
			this.$flag.style.backgroundPosition = `${-this.gap*to}px 0px`
		}

		resize () {
			this.setPosition ()
		}	

	}

	export default Flag

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.flag
		
		position absolute

		.flag-wrapper
			height 50px
			width 40px
			background-repeat no-repeat
			background-position 0 0
		

</style>


// WEBPACK FOOTER //
// flag.vue?5663c63e